import "../../css/magazine.css";
import MagazineIntro from "./sections/MagazineIntro";
import MagazineGrid from "./sections/MagazineGrid";

function Magazine() {
  return (
    <div className="container magazine-container">
      <MagazineIntro />
      <MagazineGrid />
    </div>
  );
}

export default Magazine;
